/** Values shared by every resource in the admin API. */
export const ADMIN_ROLES = ['OWNER', 'EDITOR', 'VIEWER'];
export const PUBLICATION_STATUSES = ['DRAFT', 'PUBLISHED', 'ARCHIVED'];
export const MAX_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE = 20;
//# sourceMappingURL=common.js.map